import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { map } from 'rxjs/operators';

export const withMatPaginator = (paginator: MatPaginator) => ({
	setValue: (
		value?: { pageNumber?: number; pageSize?: number },
		options: { emitEvent: boolean } = { emitEvent: true }
	): void => {
		if (value && (value.pageSize || value.pageNumber)) {
			if (options.emitEvent) {
				paginator.page.emit({
					pageIndex: value.pageNumber,
					pageSize: value.pageSize,
				} as PageEvent);
			} else {
				paginator.pageIndex = value.pageNumber;
				paginator.pageSize = value.pageSize;
			}
		}
	},
	valueChanges: paginator.page.pipe(
		map((pageEvent) => ({
			pageSize: pageEvent.pageSize,
			pageNumber: pageEvent.pageIndex,
		}))
	),
});
